import type { LOAN_REQUEST_CAR_FINANCING_WISH, LOAN_REQUEST_CAR_TYPE, LOAN_REQUEST_USAGE } from 'cpool-constants';
import { LOAN_REQUEST_CAR_FINANCING_WISHES, LOAN_REQUEST_CAR_TYPES, LOAN_REQUEST_USAGES } from 'cpool-constants';

// NOTE: these values are taken from the kredit.de website and might need to be adjusted later on
export const getRuntimeOptions = ({
    carFinancingWish,
    carType,
    usageType,
}: {
    carType: LOAN_REQUEST_CAR_TYPE | undefined;
    carFinancingWish: LOAN_REQUEST_CAR_FINANCING_WISH | undefined;
    usageType: LOAN_REQUEST_USAGE | null;
}) => {
    if (usageType === LOAN_REQUEST_USAGES.MODERNISIEREN || usageType === LOAN_REQUEST_USAGES.ENERGETISCHE_SANIERUNG) {
        return [
            { label: '12', value: 12 },
            { label: '24', value: 24 },
            { label: '36', value: 36 },
            { label: '48', value: 48 },
            { label: '60', value: 60 },
            { label: '72', value: 72 },
            { label: '84', value: 84 },
            { label: '96', value: 96 },
            { label: '108', value: 108 },
            { label: '120', value: 120 },
            { label: '180', value: 180 },
            { label: '240', value: 240 },
        ];
    }
    if (usageType === LOAN_REQUEST_USAGES.FAHRZEUGKAUF) {
        if (carFinancingWish === LOAN_REQUEST_CAR_FINANCING_WISHES.BALLOON_FINANCING) {
            // NOTE: these values are taken from the car financing calculator of kredit.de (https://kredit.de/autokredit)
            return [
                { label: '13', value: 13 },
                { label: '25', value: 25 },
                { label: '37', value: 37 },
                { label: '49', value: 49 },
                { label: '61', value: 61 },
                {
                    disabled: carType !== undefined && carType !== LOAN_REQUEST_CAR_TYPES.CAMPER_OR_CARAVAN,
                    label: '73',
                    value: 73,
                },
                {
                    disabled: carType !== undefined && carType !== LOAN_REQUEST_CAR_TYPES.CAMPER_OR_CARAVAN,
                    label: '85',
                    value: 85,
                },
            ];
        }

        return [
            { label: '12', value: 12 },
            { label: '24', value: 24 },
            { label: '36', value: 36 },
            { label: '48', value: 48 },
            { label: '60', value: 60 },
            { label: '72', value: 72 },
            { label: '84', value: 84 },
            {
                // NOTE only the camper or caravan car type can have a runtime of 96 months (https://synatix.atlassian.net/browse/KC-5957)
                disabled: carType !== undefined && carType !== LOAN_REQUEST_CAR_TYPES.CAMPER_OR_CARAVAN,
                label: '96',
                value: 96,
            },
            {
                // NOTE only the camper or caravan car type can have a runtime of 108 or 120 months (https://synatix.atlassian.net/browse/KC-5957)
                disabled: carType !== undefined && carType !== LOAN_REQUEST_CAR_TYPES.CAMPER_OR_CARAVAN,
                label: '108',
                value: 108,
            },
            {
                disabled: carType !== undefined && carType !== LOAN_REQUEST_CAR_TYPES.CAMPER_OR_CARAVAN,
                label: '120',
                value: 120,
            },
            // NOTE no car type can have a runtime of 240 months (this is not defined in the story https://synatix.atlassian.net/browse/KC-5957 but the selection is possible on kredit.de)
            { disabled: true, label: '240', value: 240 },
        ];
    }

    return [
        { label: '12', value: 12 },
        { label: '24', value: 24 },
        { label: '36', value: 36 },
        { label: '48', value: 48 },
        { label: '60', value: 60 },
        { label: '72', value: 72 },
        { label: '84', value: 84 },
        { label: '96', value: 96 },
        { label: '108', value: 108 },
        { label: '120', value: 120 },
        { label: '240', value: 240 },
    ];
};
